/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ContactTimelineFromJSON, ContactTimelineToJSON } from './ContactTimeline';
import { PageInfoFromJSON, PageInfoToJSON } from './PageInfo';
export function ContactTimelinesResponseDataFromJSON(json) {
    return ContactTimelinesResponseDataFromJSONTyped(json, false);
}
export function ContactTimelinesResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        contactTimelines: !exists(json, 'contact_timelines')
            ? undefined
            : json['contact_timelines'].map(ContactTimelineFromJSON),
        pageInfo: !exists(json, 'page_info') ? undefined : PageInfoFromJSON(json['page_info'])
    };
}
export function ContactTimelinesResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        contact_timelines: value.contactTimelines === undefined
            ? undefined
            : value.contactTimelines.map(ContactTimelineToJSON),
        page_info: PageInfoToJSON(value.pageInfo)
    };
}
